import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EDiscountType, IDiscount, IDiscountPayload, IPlanProduct } from '../models/discount.model';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IListApiModel } from '../models/api.model';

@Injectable({
  providedIn: 'root',
})
export class DiscountsService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  getPlanProducts(type: EDiscountType = EDiscountType.RECURRING): Observable<IListApiModel<IPlanProduct>> {
    return this.http.get<IListApiModel<IPlanProduct>>(environment.apiUrl + '/v1/plans/products', {
      params: new HttpParams({
        fromObject: {
          type,
        },
      }),
    });
  }

  getDiscounts(type: EDiscountType): Observable<IListApiModel<IDiscount>> {
    return this.http.get<IListApiModel<IDiscount>>(environment.apiUrl + '/v1/discounts', {
      params: new HttpParams({
        fromObject: {
          type,
        },
      }),
    });
  }

  addDiscount(payload: Partial<IDiscountPayload>): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/v1/discounts', payload);
  }

  downloadInvoice(invoiceId: number): Observable<any> {
    return this.http.get(
      environment.apiUrl + `/v1/subscriptions/receipt/${invoiceId}`,
      {
        observe: 'response',
        responseType: 'blob' as 'json',
      },
    );
  }

  updateDiscount(id: number, payload: Partial<IDiscountPayload>): Observable<any> {
    if(payload.contents) {
      payload.contents = payload.contents.map(c => {
        delete c.content_code;
        return c;
      });
    }
    return this.http.put<any>(environment.apiUrl + `/v1/discounts/${id}`, payload);
  }
}
